import React from 'react';
import PropTypes from 'prop-types';
import classes from './PeoplePicker.scss';
import { simplAvatarUrl } from '../../api/simplApi';

export class GravatarOption extends React.Component {
  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = event => {
    if (this.props.isFocused) {
      return;
    }
    this.props.onFocus(this.props.option, event);
  };

  render() {
    const avatar = simplAvatarUrl(
      this.props.option.type,
      this.props.option.value,
      32,
      32,
      'crop',
    );

    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <img src={avatar} className={classes.avatarImgOption} alt="" />
        {this.props.children}
      </div>
    );
  }
}

GravatarOption.propTypes = {
  children: PropTypes.string,
  option: PropTypes.object,
  className: PropTypes.string,
  isFocused: PropTypes.bool,
  onFocus: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

GravatarOption.defaultProps = {
  children: '',
  option: {},
  className: '',
  isFocused: false,
};

export default GravatarOption;



// WEBPACK FOOTER //
// ./src/components/PeoplePicker/GravatarOption.js